var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1808(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1808",
    "data-name": "Group 1808",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 36,
    viewBox: "0 0 24 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_down_black_24dp",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6877",
    "data-name": "Path 6877",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6878",
    "data-name": "Path 6878",
    d: "M7,10l5,5,5-5Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_down_black_24dp-2",
    "data-name": "arrow_drop_down_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6877-2",
    "data-name": "Path 6877",
    d: "M0,24H24V0H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6878-2",
    "data-name": "Path 6878",
    d: "M7,15l5-5,5,5Z",
    transform: "translate(0 -1)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1808);
export default __webpack_public_path__ + "static/media/Group_1808.8f83c5a06d1df5316959804ae21e2dcf.svg";
export { ForwardRef as ReactComponent };